import { atom } from 'jotai'

export const userInfoAtom = atom({userId:"",userName:"",refreshToken:""});